import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFormRoutingContext } from 'FormsUI/components/editor/options/routing/FormRoutingProvider';
import { getListsFromRouting, getPolicyIndicesWithIdentifier, getPolicyIndicesWithTicketProperties, listContainsField, listContainsTicketField } from 'FormsUI/utils/Routing';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';

// @ts-expect-error untyped dependency
import { getDependentFieldsOfAllTicketFields } from 'FormsUI/selectors/FormDefinition';
const useTicketPropertiesRouting = () => {
  const {
    routing,
    actions
  } = useFormRoutingContext();
  const allTicketDependentFields = useSelector(getDependentFieldsOfAllTicketFields);
  const {
    formRouting,
    formRoutingEnabled
  } = routing;
  const {
    deleteFields
  } = actions;
  const allTicketDependentFieldIdentifiers = allTicketDependentFields.map(dependentField => getPropertyObjectTypeId(dependentField));
  const isTicketsUsedInRouting = useMemo(() => {
    if (formRouting && formRoutingEnabled) {
      const lists = getListsFromRouting(formRouting);
      return listContainsTicketField(lists);
    }
    return false;
  }, [formRouting, formRoutingEnabled]);
  const isTicketsOrDependentFieldsUsedInRouting = useMemo(() => {
    if (formRouting && formRoutingEnabled) {
      const lists = getListsFromRouting(formRouting);
      const isTicketDependentFieldUsedInRouting = allTicketDependentFields.some(dependentField => listContainsField(lists, dependentField.objectTypeId, dependentField.name));
      return isTicketsUsedInRouting || isTicketDependentFieldUsedInRouting;
    }
    return false;
  }, [allTicketDependentFields, formRouting, formRoutingEnabled, isTicketsUsedInRouting]);
  const removeTicketPropertiesHandler = useCallback(() => {
    if (formRouting && !formRoutingEnabled) {
      const indices = [];
      const ticketPropertiesIndices = getPolicyIndicesWithTicketProperties(formRouting);
      indices.push(...ticketPropertiesIndices);
      allTicketDependentFieldIdentifiers.forEach(ticketDependentFieldIdentifier => {
        const policyIndicesForDependentFields = getPolicyIndicesWithIdentifier(formRouting, ticketDependentFieldIdentifier);
        indices.push(...policyIndicesForDependentFields);
      });
      deleteFields(indices);
    }
  }, [formRouting, formRoutingEnabled, deleteFields, allTicketDependentFieldIdentifiers]);
  return useMemo(() => ({
    formRouting,
    isTicketsOrDependentFieldsUsedInRouting,
    removeTicketPropertiesHandler
  }), [formRouting, isTicketsOrDependentFieldsUsedInRouting, removeTicketPropertiesHandler]);
};
export default useTicketPropertiesRouting;